var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import TaskDetailsModal from '@/modules/tasks/taskDetails/TaskDetailsModal';
import { getRelationName } from '@/shared/components/RelationName';
import ShareItemModal from '@/shared/components/ShareItemModal';
import YesNoModal from '@/shared/components/YesNoModal';
import { useDataContext } from '@/shared/providers/DataProvider';
import AuthService, { privileges } from '@/shared/services/AuthService';
import { useQueryClient } from '@tanstack/react-query';
import React, { useContext, useMemo, useState } from 'react';
import { useIntl } from 'react-intl';
import SingleRelationMailModal from '@/shared/components/email/SingleRelationMailModal';
import RegistrationModal from '@/shared/components/registration/RegistrationModal';
import CreateOneTimeTask from '@/modules/tasks/CreateOneTimeTask';
import CreateAccessToken from '@/modules/profile/accessTokens/CreateAccessToken';
import CheckboxListModal from '@/shared/components/CheckboxListModal';
import DocumentDetailsModal from '@/modules/documents/details/DocumentDetailsModal';
import { TaskQueryKey } from '../hooks/task/queryKey';
import { getRegistrationModalPropsForTask } from '../components/registration/registrationHelpers';
import { useSendTaskMail } from '../hooks/template/useSendTaskMail';
import { useCreateTaskEmail } from '../hooks/emails/useCreateTaskMail';
import { getShareItemNameForTask } from '../services/ObjectDisplayService';
export var ModalType;
(function (ModalType) {
    ModalType[ModalType["TaskDetail"] = 1] = "TaskDetail";
    ModalType[ModalType["Share"] = 2] = "Share";
    ModalType[ModalType["Delete"] = 3] = "Delete";
    ModalType[ModalType["YesNo"] = 4] = "YesNo";
    ModalType[ModalType["TaskMail"] = 5] = "TaskMail";
    ModalType[ModalType["TimeRegistration"] = 6] = "TimeRegistration";
    ModalType[ModalType["OneTimeTask"] = 7] = "OneTimeTask";
    ModalType[ModalType["CreatePat"] = 8] = "CreatePat";
    ModalType[ModalType["CheckboxList"] = 9] = "CheckboxList";
    ModalType[ModalType["DocumentDetail"] = 10] = "DocumentDetail";
})(ModalType || (ModalType = {}));
export var ModalContext = React.createContext(null);
export var useModalContext = function () {
    var ctx = useContext(ModalContext);
    if (!ctx) {
        throw new Error('Wrap app with ModalProvider');
    }
    return ctx;
};
var ModalProvider = function (_a) {
    var childElements = _a.children;
    var intl = useIntl();
    var _b = useState({}), showModalInfo = _b[0], setShowModalInfo = _b[1];
    var sendTaskMail = useSendTaskMail().sendTaskMail;
    var createTaskEmail = useCreateTaskEmail().createTaskEmail;
    var queryClient = useQueryClient();
    var _c = useDataContext(), users = _c.users, defaultCompany = _c.defaultCompany, userLanguage = _c.userLanguage;
    var canEditTasks = useMemo(function () {
        return AuthService.hasPermission({
            functionality: 'PlannedTask',
            privilege: privileges.Update,
        });
    }, []);
    var canEditDocuments = useMemo(function () {
        return AuthService.hasPermission({
            functionality: 'Documents',
            privilege: privileges.Update,
        });
    }, []);
    var modalType = showModalInfo.modalType, task = showModalInfo.task, title = showModalInfo.title, message = showModalInfo.message, registration = showModalInfo.registration, relationId = showModalInfo.relationId, documentId = showModalInfo.documentId, checkboxListItems = showModalInfo.checkboxListItems, showSelectAll = showModalInfo.showSelectAll, onSave = showModalInfo.onSave, onClose = showModalInfo.onClose, onTaskMailModalSaved = showModalInfo.onTaskMailModalSaved;
    var value = useMemo(function () { return ({
        showModalInfo: showModalInfo,
        setShowModalInfo: setShowModalInfo,
    }); }, [showModalInfo, setShowModalInfo]);
    var mapPropertiesAfterStatusChange = function (source, target) {
        if (!source || !target)
            return;
        target.status = source.status;
        target.isBlocked = source.isBlocked;
        target.inapplicable = source.inapplicable;
        target.rejected = source.rejected;
        target.taskColor = source.taskColor;
        target.deadline = source.deadline;
        target.userId = source.userId;
        target.name = source.name;
        target.remark = source.remark;
        target.hasRemark = source.hasRemark;
        target.scheduleHasRemark = source.scheduleHasRemark;
        target.year = source.year;
    };
    var onTaskDetailModalSave = function (updatedTasks) { return __awaiter(void 0, void 0, void 0, function () {
        var previousTasks;
        return __generator(this, function (_a) {
            previousTasks = queryClient.getQueryData([TaskQueryKey.PlannedTasks]);
            updatedTasks.forEach(function (newOrUpdatedTask) {
                var _a;
                var updatedTasksQueryData = __assign({}, previousTasks);
                var previousMainTasks = (_a = updatedTasksQueryData === null || updatedTasksQueryData === void 0 ? void 0 : updatedTasksQueryData.pages) === null || _a === void 0 ? void 0 : _a.flat(1);
                var isMainTask = !newOrUpdatedTask.parentId;
                var previousMainTask = previousMainTasks.find(function (x) { return x.id === (isMainTask ? newOrUpdatedTask.id : newOrUpdatedTask.parentId); });
                if (previousMainTask) {
                    var children = previousMainTask.children;
                    var updatedMainTask = isMainTask ? newOrUpdatedTask : newOrUpdatedTask.parent;
                    mapPropertiesAfterStatusChange(updatedMainTask, previousMainTask);
                    if (!isMainTask) {
                        var previousSubtask = children.find(function (x) { return x.id === newOrUpdatedTask.id; });
                        queryClient.invalidateQueries([TaskQueryKey.Remark, newOrUpdatedTask.id]);
                        if (previousSubtask) {
                            mapPropertiesAfterStatusChange(newOrUpdatedTask, previousSubtask);
                        }
                        else {
                            children = __spreadArray(__spreadArray([], children, true), [newOrUpdatedTask], false);
                        }
                        previousMainTask.children = __spreadArray([], children, true); // useEffect in KanbanBoard.tsx is not called without this line, and we need it to trigger the reshuffling of columns
                    }
                    else {
                        queryClient.invalidateQueries([TaskQueryKey.Remark, newOrUpdatedTask.id]);
                        queryClient.invalidateQueries([TaskQueryKey.PlannedTasks]);
                    }
                }
                queryClient.setQueryData([TaskQueryKey.PlannedTasks], updatedTasksQueryData);
            });
            setShowModalInfo({});
            return [2 /*return*/];
        });
    }); };
    var onTaskDetailModalClosed = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setShowModalInfo({});
            return [2 /*return*/];
        });
    }); };
    var onRegistrationCreated = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setShowModalInfo({});
            return [2 /*return*/];
        });
    }); };
    var onCloseTimeRegistration = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setShowModalInfo({});
            return [2 /*return*/];
        });
    }); };
    var onSaveEmail = function (emailViewModel) { return __awaiter(void 0, void 0, void 0, function () {
        var emailId, sendTaskMailModel;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, createTaskEmail({
                        taskId: task.id,
                        relationId: (task.relation && task.relation.id) || task.relationId,
                    })];
                case 1:
                    emailId = (_a.sent()).id;
                    sendTaskMailModel = __assign(__assign({}, emailViewModel), { emailId: emailId, language: userLanguage, linkType: emailViewModel.emailLinkType, recipients: emailViewModel.to, templateID: emailViewModel.emailTemplateId });
                    return [4 /*yield*/, sendTaskMail(sendTaskMailModel)];
                case 2:
                    _a.sent();
                    setShowModalInfo({});
                    return [4 /*yield*/, (onSave === null || onSave === void 0 ? void 0 : onSave())];
                case 3:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var onCloseModal = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setShowModalInfo({});
                    return [4 /*yield*/, (onClose === null || onClose === void 0 ? void 0 : onClose())];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var onOneTimeTaskCreated = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, queryClient.invalidateQueries([TaskQueryKey.KPI])];
                case 1:
                    _a.sent();
                    setShowModalInfo({});
                    return [2 /*return*/];
            }
        });
    }); };
    var onCloseOneTimeTask = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setShowModalInfo({});
            return [2 /*return*/];
        });
    }); };
    var renderModal = function () {
        switch (modalType) {
            case ModalType.TaskDetail: {
                if (!task)
                    return undefined;
                return (_jsx(TaskDetailsModal, { intl: intl, show: true, users: users, task: task, onSave: onTaskDetailModalSave, onClose: onTaskDetailModalClosed, onTaskMailModalSaved: onTaskMailModalSaved, disabled: !canEditTasks }));
            }
            case ModalType.Share:
                if (!task)
                    return undefined;
                return (_jsx(ShareItemModal, { show: true, type: "task", id: task.id, itemName: getShareItemNameForTask(task, intl), relationId: task.relationId, relationName: getRelationName(intl, task.relation), onClose: function () { return setShowModalInfo({}); } }));
            case ModalType.YesNo:
                return (_jsx(YesNoModal, { intl: intl, show: true, title: title, message: message, onNo: onCloseModal, onSave: function () {
                        onSave();
                        setShowModalInfo({});
                    } }));
            case ModalType.TaskMail:
                if (!task)
                    return undefined;
                return (_jsx(SingleRelationMailModal, { intl: intl, show: true, relationId: (task.relation && task.relation.id) || task.relationId, invoiceStreamId: task.invoiceStreamId, companyId: defaultCompany.id, task: task, emailContext: 11, onClose: onCloseModal, onSave: onSaveEmail, type: "task", doNotSendMail: true }));
            case ModalType.TimeRegistration:
                if (!task)
                    return undefined;
                return (_jsx(RegistrationModal, __assign({}, getRegistrationModalPropsForTask(task, registration), { show: true, onSave: onRegistrationCreated, onClose: onCloseTimeRegistration, disabled: !canEditTasks })));
            case ModalType.OneTimeTask:
                return (_jsx(CreateOneTimeTask, { show: true, users: users, onSave: onOneTimeTaskCreated, onClose: onCloseOneTimeTask, relationId: relationId }));
            case ModalType.CreatePat:
                return _jsx(CreateAccessToken, { show: true });
            case ModalType.CheckboxList:
                return (_jsx(CheckboxListModal, { title: title, items: checkboxListItems, onClose: onCloseModal, onSave: function (items) {
                        onSave(items);
                        setShowModalInfo({});
                    }, show: true, sortByLabel: false, showSelectAll: showSelectAll }));
            case ModalType.DocumentDetail:
                return (_jsx(DocumentDetailsModal, { documentId: documentId, show: true, onSave: function (updatedDocuments) {
                        // onSave(items);
                        setShowModalInfo({});
                    }, onClose: onCloseModal, disabled: !canEditDocuments }));
            default:
                return undefined;
        }
    };
    return (_jsxs(ModalContext.Provider, __assign({ value: value }, { children: [renderModal(), childElements] })));
};
export default ModalProvider;
